export default __webpack_public_path__ + "static/media/1791.5cc1be6e.png";